import { BaseSessionStore } from '~/stores/base-session.store';
import { computed } from 'mobx';
import { CXFlowSessionStore } from '~/components/ClientExperience/OneFlow/stores/cx-flow-session.store';

export class CXSessionStore extends BaseSessionStore {
    // TODO: Need to move this logic into cx-flow.context, It must stay here for now because the general api service is coupled to cx flow session store
    flowSessionStore: CXFlowSessionStore;

    setFlowSessionStore(flowSessionStore: CXFlowSessionStore) {
        this.flowSessionStore = flowSessionStore;
    }

    @computed
    get weakAuthUser() {
        return this.flowSessionStore.weakAuthUser;
    }

    @computed
    get isAuthenticating() {
        return !!this.flowSessionStore.weakAuthenticating;
    }

    @computed
    get weakAuthenticated() {
        return !!this.flowSessionStore.userWeakAuthData;
    }

    @computed
    get limitedAuthStorageKey() {
        return this.flowSessionStore.limitedAuthStorageKey;
    }
}
